const lidPattern = /@lid$/i;

export const looksLikeWhatsAppLid = (value?: string | null): boolean => {
  const raw = value?.trim();
  if (!raw) {
    return false;
  }

  if (lidPattern.test(raw)) {
    return true;
  }

  return raw.replace(/\D/g, '').length >= 14;
};

export const stripWhatsAppLidFromName = (name?: string | null): string => {
  const trimmed = name?.trim() ?? '';
  if (!trimmed) {
    return '';
  }

  if (looksLikeWhatsAppLid(trimmed)) {
    return '';
  }

  const parts = trimmed.split(/\s+/);
  if (parts.length < 2) {
    return trimmed;
  }

  const tail = parts[parts.length - 1] ?? '';
  return looksLikeWhatsAppLid(tail) ? parts.slice(0, -1).join(' ') : trimmed;
};
